type CardOperatingLossProps = {
  totalValue?: number;
  dailyValue?: number;
};

const CardOperatingLoss = (props: CardOperatingLossProps) => {
  return (
    <div
      className={`relative bg-white border border-gray5 shadow-md rounded-2xl p-5 transition hover:shadow-lg hover:scale-[1.01] animate-pulse font-bold text-red-600`}
      id="card-operating-loss"
    ><div className="flex flex-col items-center justify-center text-red-600">
        <h3 className="text-xl font-bold mb-2">Prejuízo Operacional</h3>

        <div className="flex flex-col items-center">
          <span className="text-3xl font-bold">
            {(props.totalValue ?? 0).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </span>
          <span className="text-xl font-bold">
            {(props.dailyValue ?? 0).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardOperatingLoss;
